import CtaSection from '../../section/cta-section/cta-section';
import AuthorCard from '../../simple/author-card/author-card';
import MediaRow from '../../section/media-row/media-row';
import StackedScroller from '../../section/stacked-scroller/stacked-scroller';
import BackToTop from '../../dynamic/back-to-top/back-to-top';
import LogoScroller from '../../section/logo-scroller/logo-scroller';
import HeroAnimated from '../../section/hero-animated/hero-animated';
import ContentTeaserSwipe from '../../dynamic/content-teaser-swipe/content-teaser-swipe';
import MediaGrid from '../../section/20-media-grid/media-grid';
import ContentBlock from '../../simple/content-block/content-block';
import SectionContent from '../../section/section-content/section-content';
import DesignColours from '../../section/design-colours/design-colours';
import ColorCard from '../../simple/color-card/color-card';
import LogoListItem from '../../simple/icon-list/icon-list';
import Tag from '../../simple/tag/tag';
import CaseStudyIntro from '../../section/case-study-intro/case-study-intro';
import ContactFormBlock from '../../section/contact-form-block/contact-form-block';
import CardGridSection from '../../section/card-grid-section/card-grid-section';
import Testimonial from '../../section/testimonial/testimonial';
import SectionAccent from '../../section/section-accent/section-accent';
import StatCard from '../../simple/stat-card/stat-card';
import TypographyFeature from '../../section/typography-feature/typography-feature';
import ContentTeaser from '../../section/content-teaser/content-teaser';
import MediaFeature from '../../section/10-media-feature/media-feature';
import Searchbox from '../../simple/searchbox/searchbox';
import FacetsList from '../../dynamic/facets-list/facets-list';
import Accordion from '../../dynamic/accordion/accordion';
import TabbedContent from '../../dynamic/tabbed-content/tabbed-content';
import Pagination from '../../dynamic/pagination/pagination';
import Nav from '../../dynamic/nav/nav';
import Header from '../../section/header/header';
import ResponsiveTables from '../../base/02-content/responsiveTable';
import Content from '../../base/02-content/content';

//global scope
//used for multiple instances of the same component
var globalClasses = {};
window.classes = globalClasses;

//used for class to class interactions
var mainClasses = {
  Accordion,
  BackToTop,
  Content,
  FacetsList,
  Header,
  Nav,
  ResponsiveTables,
  Searchbox,
  TabbedContent,
  ContentTeaserSwipe
};

//used for class to class interactions
var mainClassesInstances = {};

function init() {
  for (const [key, value] of Object.entries(mainClasses)) {
    mainClassesInstances[key] = new value();
  }
}

document.addEventListener('DOMContentLoaded', init);

export default mainClasses;
